import script from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=bf38712c&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf38712c"]])

export default __exports__